export let dateList = [...new Array(31)].map((_, index) => {
  // this return a list of days from 01 - 31

  const paddedDay = String(`${"0" + (index + 1)}`).slice(-2);
  return {
    label: paddedDay,
    value: paddedDay,
  }
});

export const getYearList = (person = 'adult') => {
  const adultYear = new Date().getFullYear() - 17;

  const yearByPerson = {
    'child': () => yearList.filter(d => d.value >= adultYear),
    'adult': () => yearList.filter(d => d.value <= adultYear),
  };

  return yearByPerson[person]();
};

const normalizeYearValues = (additional) => ({
  label: new Date().getFullYear() + additional,
  value: new Date().getFullYear() + additional,
});

// 101 years back (currentYear down to currentYear-100) to support the adult
// age validation range (up to 99 years old, whose DOB can be as early as
// currentYear-100 if their birthday hasn't occurred yet this year).
export const yearList = [...new Array(101)].map((_, index) => normalizeYearValues(-index));
export const futureYearList = [...new Array(11)].map((_, index) => normalizeYearValues(index));

export const monthList = [
  { label: 'Januari', value: '01' },
  { label: 'Februari', value: '02' },
  { label: 'Maret', value: '03' },
  { label: 'April', value: '04' },
  { label: 'Mei', value: '05' },
  { label: 'Juni', value: '06' },
  { label: 'Juli', value: '07' },
  { label: 'Agustus', value: '08' },
  { label: 'September', value: '09' },
  { label: 'Oktober', value: '10' },
  { label: 'November', value: '11' },
  { label: 'Desember', value: '12' },
];

export const numericMonthList = monthList.map(month => ({
  label: month.value,
  value: month.value,
}));

export const durationMonthList = monthList.map(month => ({
  label: `${Number(month.value)} Bulan`,
  value: month.value,
}));
